import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { LoaderOverlayService } from 'src/app/core/services/loader-overlay.service';
import { CommonFunctions } from 'src/app/shared/common-functions';
import { MenuService } from 'src/app/shared/services/menu.service';
import { StorageService } from 'src/app/shared/services/storage.service';
import { ViewCartService } from 'src/app/shared/services/view-cart.service';
declare var dataLayer;
@Component({
  selector: 'app-choose-again-dialog',
  templateUrl: './choose-again-dialog.component.html',
  styleUrls: ['./choose-again-dialog.component.scss'],
})
export class ChooseAgainDialogComponent implements OnInit {
  public isMobile: boolean;
  public isClicked: boolean = false;
  public userType: string;
  public userId: any;
  public tierType: any;
  public productQty: any;
  public gaData: any = [];
  public itemPrice;
  public data: any;
  constructor(
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public matdata,
    public commonFunctions: CommonFunctions,
    private menuService: MenuService,
    private cartService: ViewCartService,
    private loaderOverlayService: LoaderOverlayService,
    public dialogRef: MatDialogRef<ChooseAgainDialogComponent>,
    private commonFunction: CommonFunctions,
    private storageService: StorageService
  ) {
    this.data=matdata.data;
    this.isMobile = this.commonFunctions.identifyDeviceType();
    this.userType = this.commonFunction.getUserType();
    this.userId = this.commonFunction.getUserId();
    this.tierType = this.commonFunction.getTierType();
  }
  ngOnInit(): void {
    let checkGAData = JSON.parse(sessionStorage.getItem('gaData'));
    this.gaData = checkGAData ? checkGAData : [];
    this.lastaddedItem();
  }
  /**
   * Method to show price of last added item
   */
  lastaddedItem() {
    let id = this.data['id'];
    let localcartItem = JSON.parse(sessionStorage.getItem('localcartItem'));
    if (localcartItem) {
      localcartItem = localcartItem.reverse();
      let lastproduct = localcartItem.find((data) => data.id === id);
      this.data = { ...this.data };
      this.itemPrice = lastproduct.myprice;
    }
  }
  closeDialog() {
    this.dialogRef.close();
  }
  chooseAgain() {
    localStorage.setItem('selectedItem', JSON.stringify(this.data));
    this.menuService.sendCloseSheetInfo(true);
    this.dialogRef.close();
    this.commonFunction.dynamicURL(this.data, []);
  }
  totalBasketItem: any;
  addItemEvent: boolean;
  getbasketItem() {
    this.addItemEvent = true;
    let basketId = this.storageService.getBasketId();
    if(basketId){
    let data = {
      basketId: basketId,
    };
    this.cartService.getbasketItem(data).subscribe(
      (res) => {
        this.totalBasketItem = res['response'];
        this.repeatLast(this.totalBasketItem, basketId);
        localStorage.setItem('snackbarData', JSON.stringify(res));
      },
      (error) => {
        this.showError(error);
      }
    );
  }
  }
  repeatLast(totalBasketItem, basketId) {
    this.isClicked = this.loaderOverlayService.showShimmerBtn();
    let filterItem;
    if(this.matdata.isCart === true){
      filterItem = totalBasketItem['items'].filter(
        (itm) => itm.lineItemId === this.data['lineID']
      );
    }else{
      filterItem = totalBasketItem['items'].filter(
        (itm) => itm.id === this.data['id']
      );
    }
    let reqBody = {
      basketId: basketId,
      lineItemId: filterItem[0]['lineItemId'],
      id: this.data['id'],
      options: filterItem[0]['options'] ? filterItem[0]['options'] : [],
      quantity: filterItem[0]['quantity'] + 1,
    };
    this.cartService.updateLineItem(reqBody).subscribe(
      (res) => {
        this.getupdatedBasket();
        this.productQty = filterItem[0]['quantity'] + 1;
        this.addToCartProductGA();
        this.isClicked = this.loaderOverlayService.hideShimmerBtn();
      },
      (error) => {
        this.showError(error);
      }
    );
  }
  showError(err) {
    this.isClicked = this.loaderOverlayService.hideShimmerBtn();
    this.commonFunctions.displaySnackBarMessage(
      err.error.response[0],
      'failure'
    );
  }
  getupdatedBasket() {
    let basketId = this.storageService.getBasketId();
    if(basketId){
    let data = {
      'basketId': basketId,
    };
    this.cartService.getbasketItem(data).subscribe((res) => {
        localStorage.setItem('snackbarData', JSON.stringify(res));
        this.dialogRef.close(res);
      },
      (error) => {
        this.showError(error);
      }
    );
  }
  }
  chooseAgainGA() {
    dataLayer.push({
      event: 'order_choose_again_click',
      userID: this.userId,
      user_type: this.userType,
      tier: this.tierType,
    });
  }
  addToCartProductGA() {
    let item = this.data;
    let data = JSON.parse(sessionStorage.getItem('state'));
    let index = Number(sessionStorage.getItem('productDispIndex'));
    let promoName = sessionStorage.getItem('promo_banner_name');
    let promoNameNA = sessionStorage.getItem('promo_name');
    let promoId = Number(sessionStorage.getItem('promo_banner_id'));
    let re = new RegExp(promoName, 'g');
    let result = item.name.match(re);
    let snackbar = JSON.parse(localStorage.getItem('snackbarData'));
    let snackbarData = snackbar ? snackbar.response : '';
    let prodQty;
    let itemListId;
    let itemListName = sessionStorage.getItem('itemPage');
    if (itemListName == 'Barista Recommends') {
      itemListId = 'L006';
    } else if (itemListName == 'Latest Offerings') {
      itemListId = 'L007';
    } else if (itemListName == 'Menu Products') {
      itemListId = 'L004';
    } else if (itemListName == 'Reorder Favourites') {
      itemListId = 'L001';
    }
    if (snackbarData) {
      if (snackbarData['items'].length != 0) {
        snackbarData.items.forEach((product) => {
          if (product.id == item.id) {
            prodQty = product.quantity + 1;
          }
        });
      }
    }
    dataLayer.push({
      event: 'add_to_cart',
      userID: this.userId,
      user_type: this.userType,
      tier: this.tierType,
      ecommerce: {
        items: [
          {
            item_name: item.name,
            item_id: item.id,
            item_brand: 'Tata',
            affiliation: data ? data.storeDetails.shopName : 'NA',
            currency: 'INR',
            item_category: item.parameters[1].value,
            price: item.defaultPrice,
            item_list_name: itemListName,
            item_list_id: itemListId,
            item_variant: 'NA',
            promotion_name: promoId === +item.id ? promoName : promoNameNA,
            index: index + 1,
            quantity: prodQty == null ? 1 : prodQty,
          },
        ],
      },
    });
    let gaSelectedItem = {
      item_name: item.name,
      item_id: item.id,
      item_brand: 'Tata',
      affiliation: data ? data.storeDetails.shopName : 'NA',
      currency: 'INR',
      item_category: item.parameters[1].value,
      price: item.defaultPrice,
      item_list_name: itemListName,
      item_list_id: itemListId,
      item_variant: 'NA',
      promotion_name: promoId === +item.id ? promoName : promoNameNA,
      index: index,
      quantity: prodQty == null ? 1 : prodQty,
    };
    if (this.gaData.length > 0) {
      this.gaData.forEach((elem, i) => {
        if (elem.item_id == item.id) {
          this.gaData.splice(i, 1);
        }
      });
      this.gaData.push(gaSelectedItem);
    } else {
      this.gaData.push(gaSelectedItem);
    }
    sessionStorage.setItem('gaData', JSON.stringify(this.gaData));
  }
}
